import React from "react";
// import "./Row2.css";

function Row2(props) {
  const { nameOfTheCandidate, rajendraKumar, surname, saturday } = props;

  return (
    <div className="row-2">
      <div className="frame-2-3">
        <div className="column-1-5">
          <div className="name-of-the-candidate avertastd-bold-limed-spruce-40px">{nameOfTheCandidate}</div>
        </div>
        <div className="column-2-2">
          <div className="rajendra-kumar avertastd-bold-limed-spruce-40px">{rajendraKumar}</div>
        </div>
      </div>
      <div className="frame-3-1">
        <div className="column-1-6">
          <div className="surname avertastd-bold-limed-spruce-40px">{surname}</div>
        </div>
        <div className="column-2-2">
          <div className="saturday avertastd-bold-limed-spruce-40px">{saturday}</div>
        </div>
      </div>
    </div>
  );
}

export default Row2;
